var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('last-documents-component',{attrs:{"ui":_vm.ui,"routeDocuments":_vm.routeDocuments}})}
var staticRenderFns = []

export { render, staticRenderFns }